import { assetURL } from 'shared/helpers/assetHelper';

export default function getTnc(isSSR = false) {
  const tncBukaemasPdf = isSSR ? '' : assetURL('pdfs/tnc_tabungan_emas_v2-2.pdf');

  return {
    title: 'Ketentuan Penting BukaEmas',
    items: [
      `BukaEmas adalah salah satu fitur yang ditawarkan oleh Bukalapak untuk memfasilitasi Pengguna dalam melakukan transaksi emas.`,
      `Bukalapak <strong>BUKAN</strong> sebagai penjual dan/atau penyedia emas pada fitur BukaEmas melainkan bekerja sama dengan Partner Bukalapak, yaitu PT Indonesia Logam Pratama (<strong>Treasury</strong>) Jual-Beli Emas Fasilitas Penitipan (“Tabungan Emas”).`,
      `Pengguna wajib membaca dan memahami seluruh <a href="${tncBukaemasPdf}" target="_blank" download> Syarat dan ketentuan </a> untuk Jual-Beli Emas Fasilitas Penitipan (“Tabungan Emas”) sebelum melakukan transaksi Tabungan Emas di BukaEmas`,
    ],
    cta: 'Saya Mengerti',
  };
}
